import React from 'react';

const DiscountSection = () => {
  return (
    <section className="elementor-section row-top" data-id="3b58066" data-element_type="section">
      <div className="elementor-container elementor-column-gap-default">
        {/* Left Column - Image with Discount */}
        <div className="elementor-column elementor-col-50 elementor-top-column" data-id="0d84cd6" data-element_type="column">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-widget-container">
              <div className="gva-element-gva-image-content gva-element">
                <div className="gsc-image-content skin-v1">
                  <div className="image">
                    <img
                      loading="lazy"
                      decoding="async"
                      width="624"
                      height="579"
                      src="/images/about-one-img-1.png"
                      alt="Discount"
                      className="attachment-full"
                    />
                  </div>
                  <div className="box-content">
                    <div className="sub-title">Meghana Cab</div>
                    <h2 className="title"><span>Service</span></h2>
                  </div>
                  <div className="icon_box_content">
                    <div className="content-inner">
                      <div className="ib-icon">
                        <i className="flaticon-phone-ringing" aria-hidden="true"></i>
                      </div>
                      <div className="ib-content">
                        <h3 className="title">Book Tour Now</h3>
                        <div className="desc">+91 9075462128</div>
                      </div>
                    </div>
                  </div>
                  <a href="/booking" className="link-overlay" aria-label="Book Tour Link"></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Text & List */}
        <div className="elementor-column elementor-col-50 elementor-top-column pt-3" data-id="bf041b1" data-element_type="column">
          <div className="elementor-widget-wrap elementor-element-populated">
            <div className="elementor-widget-container">
              <div className="gva-element-gva-heading-block gva-element">
                <div className="align-left style-1 widget gsc-heading box-align-left auto-responsive">
                  <div className="content-inner">
                    <div className="sub-title"><span>Welcome to Meghana Cabs</span></div>
                    <h2 className="title py-3 .section-title__title"><span>Discover the Comfort and Convenience of Traveling with Meghana Cabs</span></h2>
                    <div className="about-one__right-text text-dark">
                      Welcome to Meghana Cabs, your trusted partner for all your transportation needs. Whether you are a local looking for a hassle-free ride across town or a traveller in search of a reliable way to explore the beauty of our city, Meghana Cabs has got you covered.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ul className="elementor-icon-list-items">
              <li className="elementor-icon-list-item">
                <span className="elementor-icon-list-icon"><i className="fas fa-check-circle" aria-hidden="true"></i></span>
                <span className="elementor-icon-list-text text-dark"> Invest in your simply neighborhood</span>
              </li>
              <li className="elementor-icon-list-item">
                <span className="elementor-icon-list-icon"><i className="fas fa-check-circle" aria-hidden="true"></i></span>
                <span className="elementor-icon-list-text text-dark">Support people in free text extreme</span>
              </li>
              <li className="elementor-icon-list-item">
                <span className="elementor-icon-list-icon"><i className="fas fa-check-circle" aria-hidden="true"></i></span>
                <span className="elementor-icon-list-text text-dark">Largest global industrial business</span>
              </li>
            </ul>

            <div className="elementor-widget-container py-4 ps-5">
              <a href="/booking" className="btn-theme">Book with us now</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscountSection;
